let tabHeader = document.getElementsByClassName("tab-header")[0];
let tabIndicator = document.getElementsByClassName("tab-indicator")[0];
let TabBody = document.getElementsByClassName("tab-body")[0];
let tabsPane = tabHeader.getElementsByTagName("div");
let tabsContainer = document.getElementById("stick-product-tabs");

for (let i=0;i<tabsPane.length;i++){

      tabsPane[i].addEventListener("click",function(){ 

      let parentHeight = TabBody.offsetHeight;
      TabBody.setAttribute('style', 'min-height:' + parentHeight + 'px');    

      tabHeader.getElementsByClassName("active")[0].classList.remove("active");
      tabsPane[i].classList.add("active");

      TabBody.getElementsByClassName("active")[0].classList.remove("active");
      TabBody.getElementsByClassName("infotab")[i].classList.add("active");
  
            const width = "calc(100% / 2)";
            tabIndicator.style.left = `calc(${width} * ${i})`;

    });
}
          
